var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { observable, makeObservable } from 'mobx';
import { ChannelName, LoadStatus, MediaLabel, PlayStatus } from '../../learnware/LearnwareEnums';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { IntentInfo } from './modules/IntentInfo';
import { IntentStart } from './modules/IntentStart';
import { IntentAbort } from './modules/IntentAbort';
import { IntentActions } from './modules/IntentActions';
import { IntentSettings } from './modules/IntentSettings';
export class PlaybackIntent {
    id = nanoid(6);
    attachedMedium;
    triggerAt;
    manualPlayableFile;
    app;
    answerId;
    questionId;
    constructor({ app, attachedMedium, triggerAt }) {
        makeObservable(this);
        this.app = app;
        this.attachedMedium = attachedMedium;
        this.triggerAt = triggerAt;
        if (this.app.answer) {
            this.answerId = this.app.answer.id;
        }
        if (this.app.question) {
            this.questionId = this.app.question.id;
        }
    }
    startDate;
    endDate;
    progressInSeconds = 0;
    loadingPercentage = 0;
    wasAbortedBy;
    playStatus = PlayStatus.Pending;
    loadStatus = LoadStatus.Loading;
    intentSettings = new IntentSettings();
    get mediaPlayer() {
        return this.app.mediaPlayer;
    }
    get intentInfo() {
        return new IntentInfo(this);
    }
    get intentActions() {
        return new IntentActions(this);
    }
    get intentStart() {
        return new IntentStart(this);
    }
    get intentAbort() {
        return new IntentAbort(this);
    }
    get medFile() {
        if (this.manualPlayableFile)
            return this.manualPlayableFile;
        return this.attachedMedium.trait.value;
    }
    get snd() {
        return this.medFile;
    }
    get mediumLabel() {
        return (this.medFile && this.medFile.mediumLabel) || MediaLabel.None;
    }
    get intentHandler() {
        return null;
    }
    get volume() {
        if (this.triggerAt && this.triggerAt.atOf.playbackVolume)
            return this.triggerAt.valueOf.playbackVolume;
        if (this.attachedMedium && this.attachedMedium.atOf.playbackVolume)
            return this.attachedMedium.valueOf.playbackVolume;
        return 1;
    }
    get channel() {
        if (this.intentSettings.playbackChannel === ChannelName.Voice)
            return this.app.mediaPlayer.channelVoice;
        if (this.intentSettings.playbackChannel === ChannelName.Background)
            return this.app.mediaPlayer.playerChannels.channelBackground;
        return this.app.mediaPlayer.playerChannels.channelSound;
    }
}
__decorate([
    observable.ref
], PlaybackIntent.prototype, "startDate", void 0);
__decorate([
    observable.ref
], PlaybackIntent.prototype, "endDate", void 0);
__decorate([
    observable
], PlaybackIntent.prototype, "progressInSeconds", void 0);
__decorate([
    observable
], PlaybackIntent.prototype, "loadingPercentage", void 0);
__decorate([
    observable
], PlaybackIntent.prototype, "wasAbortedBy", void 0);
__decorate([
    observable
], PlaybackIntent.prototype, "playStatus", void 0);
__decorate([
    observable
], PlaybackIntent.prototype, "loadStatus", void 0);
__decorate([
    memoize
], PlaybackIntent.prototype, "intentInfo", null);
__decorate([
    memoize
], PlaybackIntent.prototype, "intentActions", null);
__decorate([
    memoize
], PlaybackIntent.prototype, "intentStart", null);
__decorate([
    memoize
], PlaybackIntent.prototype, "intentAbort", null);
